export default {
  copyright: "{{projectToken}} 2025. Powered by {{projectToken}} DAO",
  termsOfService: "Términos de Servicio",
}
